<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { ModalFooter } from "sveltestrap";
  import { createForm } from "svelte-forms-lib";
  import api from "/business/api";
  import HCaptcha from "/shared/HCaptcha.svelte";
  import { notification } from "/shared/utils";
  import ErrorMessage from "/shared/ErrorMessage.svelte";

  export let businessCode;

  const dispatch = createEventDispatcher();

  let captcha;

  const { form, handleChange, handleSubmit } = createForm({
    initialValues: {
      guest_name: "",
      guest_email: "",
      guest_question: "",
      hcaptchaToken: "",
    },
    onSubmit: async () => {
      // don't submit if captcha not good
      if (!$form.hcaptchaToken) return;

      try {
        await api.apiGuestQuestionCreate({
          guest_name: $form.guest_name,
          guest_email: $form.guest_email,
          guest_question: $form.guest_question,
          business_profile: businessCode,
          token: $form.hcaptchaToken,
        });
      } catch (error) {
        if (error.response?.data?.token) {
          captcha.reset();
          notification.error("Captcha verification failed. Please try again.");
          return;
        }
        notification.reportError(error);
        return;
      }
      notification.success("Question successfully submitted!");
      dispatch("close");
    },
  });
</script>

<form on:submit={handleSubmit}>
  <div class="container">
    <div class="row my-3">
      <div class="col-12">
        <div class="form-group">
          <label for="guest_name" class="form-label">Your Name*</label>
          <input
            name="guest_name"
            class="form-control large-control"
            on:change={handleChange}
            bind:value={$form.guest_name}
            required />
          <ErrorMessage name={"guest_name"} />
        </div>

        <div class="form-group">
          <label for="guest_email" class="form-label">Email Address*</label>
          <input
            name="guest_email"
            type="email"
            class="form-control large-control"
            on:change={handleChange}
            bind:value={$form.guest_email}
            required />
          <ErrorMessage name={"guest_email"} />
        </div>

        <div class="form-group">
          <label for="guest_question" class="form-label">Your Question*</label>
          <textarea
            class="form-control"
            id="recommendation-text"
            aria-describedby="guestMessage"
            rows="4"
            name="guest_question"
            on:change={handleChange}
            bind:value={$form.guest_question}
            required />
          <ErrorMessage name={"guest_question"} />
        </div>

        <div class="text-center">
          <HCaptcha
            bind:this={captcha}
            on:success={(ev) => ($form.hcaptchaToken = ev.detail.token)} />
        </div>
      </div>
    </div>
  </div>
  <ModalFooter>
    <button
      type="button"
      class="btn btn-outline-muted"
      on:click={() => dispatch("close")}>
      Cancel
    </button>
    <button type="submit" class="btn btn-primary px-5">Send</button>
  </ModalFooter>
</form>
